<template>
  <base-popup ref="popup" :withoutIcon="true">
    <template #header="{ close }">
      <div class="payment-popup__header">
        <h3 class="payment-popup__title">{{ $t("payment.choose_method") }}</h3>
        <span class="payment-popup__close" @click="close" aria-label="Закрити">
          <close-icon />
        </span>
      </div>
    </template>

    <template #content>
      <div v-if="cards.length" class="payment-popup__cards">
        <label v-for="c in cards" :key="c.id" class="payment-popup__card">
          <input type="radio" name="card" :value="c.id" v-model="selected" />
          <div class="payment-popup__card-info">
            <span class="brand">{{ c.brand }}</span>
            <span class="mask">•••• {{ c.last4 }}</span>
          </div>
        </label>

        <app-checkbox v-model="agreed">
          {{ $t("payment.offer_agree") }}
        </app-checkbox>
      </div>

      <div v-else class="payment-popup__empty">
        <empty-cards-icon class="payment-popup__icon" />

        <primary-button
          class="payment-popup__add-card"
          :text="$t('payment.add_card')"
          @click="goToCards"
        />
      </div>
    </template>

    <template #actions>
      <primary-button
        v-if="cards.length"
        class="payment-popup__btn-primary"
        :disabled="payDisabled"
        :text="isProcessing ? $t('loading') : $t('payment.pay_token')"
        @click="handlePayToken"
      />

      <button v-if="false" class="payment-popup__other-link" @click="$emit('pay-other')">
        {{ $t("payment.pay_other") }}
      </button>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from "../base/BasePopup.vue";
import PrimaryButton from "@/components/buttons/PrimaryButton";
import EmptyCardsIcon from "@/components/icons/EmptyCardsIcon.vue";
import AppCheckbox from "@/components/inputs/AppCheckbox.vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";

export default {
  name: "PaymentPopup",
  components: {
    BasePopup,
    PrimaryButton,
    EmptyCardsIcon,
    AppCheckbox,
    CloseIcon,
  },
  props: { cards: { type: Array, required: true } },
  data() {
    return {
      selected: null,
      agreed: false,
      isProcessing: false,
    };
  },
  computed: {
    payDisabled() {
      return !this.selected || !this.agreed || this.isProcessing;
    },
  },
  methods: {
    async handlePayToken() {
      if (this.isProcessing) return;
      this.isProcessing = true;

			this.$emit('pay-token', this.cards.find(c => c.id === this.selected));
			this.$refs.popup.confirm(true);
    },
    async open() {
      this.selected = null;
      this.agreed = false;
      return this.$refs.popup.open();
    },
    goToCards() {
      this.$router.push("/me/user-cards");
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .popup {
  max-width: 640px;
  min-height: 440px;
  width: 95%;
}

.payment-popup__header {
  position: relative;
  padding: 10px 5px;
}

.payment-popup__title {
  display: flex;
  justify-content: center;
  color: var(--text1, #5e6277);
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.payment-popup__close {
  position: absolute;
  top: -2rem;
  right: 1rem;
}

.payment-popup__cards {
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.payment-popup__card {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s;
}
.payment-popup__card input {
  margin-right: 0.75rem;
}
.payment-popup__card:hover {
  border-color: #58acfa;
}
.payment-popup__card-info {
  display: flex;
  gap: 0.5rem;
}
.brand {
  font-weight: 500;
  color: #27365b;
}
.mask {
  color: #606b82;
}

.payment-popup__agreement {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
  color: #27365b;
}

.payment-popup__btn-primary {
  margin: 0.5rem 1.5rem 0.75rem;
  text-align: center;
  min-width: 232px;
}

.payment-popup__other-link {
  background: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 2.5rem;
  bottom: 3rem;
  color: #5c91f2;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.payment-popup__empty {
  padding: 2rem 1.5rem 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.payment-popup__add-card {
  margin-top: 0.5rem;
}
</style>
